export default {
  reports: {
    becauseYouAnswered: "Because you answered {answer} to",
    noRecommendations: "There are no recommendations based on the answers you provided.",
    report: "Report",
  },
};
